import log from 'loglevel';
import FetchAPI from './fetchAPI';
import { notify } from 'Components/Notify';

import i18n from 'i18next';
import auth from './auth';
import { AUTHENTICATE } from 'constants/apis';
import { getRegionData } from '../constants/regions';


export const HydrateIdentityToken = async () => {
  if (auth && !auth.isAuthenticated() && auth.isRefreshTokenActive()) {
    const options = {
      headers: {
        RefreshToken: auth.getRefreshToken(),
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    };

    try {
      const data = await FetchAPI.Get(AUTHENTICATE, options);
      localStorage.setItem('IdentityToken', data.headers.get('IdentityToken'));
      localStorage.setItem('RefreshToken', data.headers.get('RefreshToken'));
    } catch (e) {
      notify.error(i18n.t('common:TokenInvalidMessage'));
      setTimeout(() => { window.location.href = '/login' }, 3000);
    }
  }

};


const errorCallback = (err, data, isCompHandlesError) => {
  const options = {
    ...err,
    errorMsg: 'error',
    data,
  };

  if (
    err.response &&
    err.response.status === 401 &&
    localStorage.getItem('IdentityToken') &&
    auth.isRefreshTokenActive()
  ) {
    notify.error(i18n.t('common:TokenInvalidMessage'));
    setTimeout(() => { window.location.href = '/login' }, 3000);
  }

  if (err.name !== 'AbortError') {
    // notify.error(`API Error! ${JSON.stringify(err)}`);
    throw { ...options, status: 'error' };
  } else {
    throw { ...options, status: 'cancelled' };
  }
};

const checkResponse = (data, isCompHandlesError) => {
  // if (data && (data.statusCode === '200' || data.documentKey || data.blob || data.type === 'image/png')) {
  if (data && data.status >= 300) {
    log.error('API Fetch Error');
  }

  return data || {};
};

const withAuth = (func, auth, method) => {
  return async function (
    url,
    options = { isGlobalLoader: false },
    data = {},
    mimeType,
    isCompHandlesError = false,
  ) {
    // swapping data and options so we don't have to pass empty {} everytime for Post, Put and Patch
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
      [options, data] = [data, options];
    }

    const { apiURL: baseURL } = getRegionData(localStorage.getItem('Region'));

    await HydrateIdentityToken();

    if (auth && auth.isAuthenticated()) {
      if (!('headers' in options)) {
        options.headers = {};
      }
      if (options.mimeType === 'multipart/form-data' || options.fileOperation) {
        const accessToken = auth.getAccessToken();
        options.headers.accesstoken = accessToken;
      }

      options.headers['Cache-Control'] = 'no-cache';
      options.headers['Pragma'] = 'no-cache';
      options.headers.IdentityToken = auth.getIdentityToken();
    }

    let masterURL = baseURL + url;

    if (options.customURL && options.customURL !== null) {
      masterURL = options.customURL
    }

    /* Error handling for the fetch call */
    return func
      .call(this, masterURL, options, data, mimeType, isCompHandlesError)
      .then((data) => {
        /**
         * Error handling for the fetch call.
         * @param {boolean} isCompHandlesError - This parameter explains is there any error call back at component level.
         * response status Success - return the data
         * response status Fail -  no error call bak alert the error and return error code
         * API falilure  - alert the error and return error code
         */
        return checkResponse(data, isCompHandlesError);
      })
      .catch((err, req, res) => {
        return errorCallback(err, req, res, data, isCompHandlesError);
      });
  };
};

const Get = withAuth(FetchAPI.Get, auth, 'GET');
const Post = withAuth(FetchAPI.Post, auth, 'POST');
const Put = withAuth(FetchAPI.Put, auth, 'PUT');
const Patch = withAuth(FetchAPI.Patch, auth, 'PATCH');
const Delete = withAuth(FetchAPI.Delete, auth, 'DELETE');

export default {
  Get,
  Post,
  Put,
  Patch,
  Delete,
  HydrateIdentityToken,
};



// WEBPACK FOOTER //
// ./src/helpers/fetch.js